import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { UserAvatar, SectionLabel } from "@/components/ui-nw/UserAvatar";
import { LANDING } from "@/constants/testIds";

export const CreatorsStrip = () => {
  const [creators, setCreators] = useState([]);
  useEffect(() => { publicApi.get("/creators").then((r) => setCreators(r.data)).catch(() => {}); }, []);

  return (
    <section className="space-y-4">
      <div className="flex items-end justify-between">
        <div className="space-y-1">
          <SectionLabel>New on the wave</SectionLabel>
          <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">Fresh AI Creators</h2>
        </div>
      </div>
      {creators.length === 0 ? (
        <p className="rounded-2xl border border-dashed border-white/15 p-6 text-sm text-slate-500">Be the first creator to claim your spot.</p>
      ) : (
        <div data-testid={LANDING.creatorsList} className="flex gap-3 overflow-x-auto pb-2 -mx-4 px-4 snap-x scrollbar-none">
          {creators.map((c) => (
            <Link key={c.user_id} to={`/u/${c.username}`} data-testid={`${LANDING.creatorCard}-${c.username}`}
              className="snap-start shrink-0 w-36 rounded-2xl border border-white/10 bg-nw-surface/60 p-4 text-center transition-[border-color,transform] duration-200 hover:-translate-y-1 hover:border-nw-red/50">
              <div className="flex justify-center"><UserAvatar profile={c} size="h-16 w-16" /></div>
              <p className="mt-3 truncate font-display font-semibold text-white">{c.display_name}</p>
              <p className="truncate font-mono text-[11px] text-slate-500">@{c.username}</p>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
};
